import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import shortid from 'shortid';

import { Title } from 'components/typography';
import Image from 'components/image';
import Feature from 'components/feature';
import { CTAS } from 'context/solutions/constants';

import {
  sectionsContainer,
  sectionContainer,
  sectionContainerReversed,
  sectionTitle,
  sectionDescription,
  sectionImage,
  sectionImageMobile,
  readyToTradeSection,
  ctasContainer,
  readyToTradeCtas,
  descriptionContainer,
  solutionTemplateContainer,
} from './scss/SolutionTemplate.module.scss';
import { getCTAs } from './SolutionTemplate.helpers';

const SolutionTemplate = ({ sections }) => {
  return (
    <section className={solutionTemplateContainer}>
      <div className={sectionsContainer}>
        {sections.map((section, index) => {
          const reversed = index % 2 > 0;
          const sectionContainerClassNames = classNames(
            sectionContainer,
            reversed && sectionContainerReversed
          );
          return (
            <div className={sectionContainerClassNames} key={shortid()}>
              <div className={descriptionContainer}>
                <div>
                  <Title
                    size="xl"
                    value={section.title}
                    className={sectionTitle}
                  />
                  <div className={classNames(sectionImageMobile)}>
                    <Image src={section.image} alt={section.title} />
                  </div>
                  <p className={sectionDescription}>{section.description}</p>
                  <Feature>
                    <div className={ctasContainer}>{getCTAs(section.ctas)}</div>
                  </Feature>
                </div>
              </div>
              <div className={sectionImage}>
                <Image src={section.image} alt={section.title} />
              </div>
            </div>
          );
        })}
      </div>
      <Feature>
        <div className={readyToTradeSection}>
          <Title size="xl" value="ready to trade ?" />
          <p>
            It’s quick and easy to get started – even with a small deposit.{' '}
            <br />
            Apply in minutes with our simple application process.
          </p>
          <div className={readyToTradeCtas}>
            {getCTAs([CTAS.OPEN_LIVE_ACCOUNT, CTAS.TRY_DEMO])}
          </div>
        </div>
      </Feature>
    </section>
  );
};

SolutionTemplate.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default SolutionTemplate;
